import geolib from 'geolib'
import $cache from './cache'

export default class Geo {
  static async zip (zip) {
    if (!$cache.has(`geo:${zip}`)) {
      let result = await fetch(`https://dawa.aws.dk/postnumre/${zip}?format=geojsonz&struktur=flad`).then(res => res.json())
      let { latitude, longitude } = geolib.getCenter(result.geometry.coordinates[0][0])

      result.geometry.location = { lat: parseFloat(latitude), lng: parseFloat(longitude) }

      $cache.set(`geo:${zip}`, result)
    }

    return $cache.get(`geo:${zip}`)
  }
}



// WEBPACK FOOTER //
// ./src/library/geo.js